import { graphql, Link } from 'gatsby';

import { ConsultationTeaser } from '@mewa/ui';

import { imagePopulate } from '../../../../libs/strapi-populates';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiResponsiveImageData } from './image';

export const ConsultationTeaserFragment = graphql`
  fragment ConsultationTeaserFragment on STRAPI__COMPONENT_SHARED_CONSULTATION_TEASER {
    textblocks {
      headline
      text
    }
    headline
    cta {
      text
      url
    }
    image {
      ...StrapiImageFragment
    }
    strapi_component
  }
`;

export const componentName = 'shared.consultation-teaser';

export type ConsultationTeaserData = {
  strapi_component: typeof componentName;
  headline: string;
  textblocks: {
    headline: string;
    text: string;
  }[];
  cta: {
    text: string;
    url: string;
  } | null;
  image: StrapiResponsiveImageData;
};

export type ConsultationTeaserPreview = ConsultationTeaserData;

export const isButton = (
  component: PossibleContentSections,
): component is ConsultationTeaserData => {
  return component.strapi_component === componentName;
};

export const StrapiConsultationTeaser = ({
  image,
  headline,
  textblocks,
  navigationLinks,
  langPrefix,
  cta,
  className = '',
}: ComponentProps<ConsultationTeaserData> & { className?: string }) => {
  return (
    <ConsultationTeaser
      image={<StrapiImage responsiveImage={image} />}
      headline={headline}
      textblocks={textblocks}
      className={className}
      link={
        cta
          ? {
              component: Link,
              props: {
                to: `${langPrefix}/${navigationLinks.conversion.contact.slug}`,
              },
            }
          : undefined
      }
      linkLabel={cta?.text}
    />
  );
};

export const config = {
  isComponent: isButton,
  Component: StrapiConsultationTeaser,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {
    image: imagePopulate,
    cta: '*',
    textblocks: '*',
  },
  mapProperties: (component): ConsultationTeaserData | null =>
    component.strapi_component === componentName ? component : null,
};
